import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@growthaxl/web-foundation';
import { ESASparkIcon } from '../panel/ESASparkIcon';

/**
 * Briefing empty-state: sparkle icon + "Ask me anything" prompt.
 * Suggestion chips are intentionally NOT rendered here — they live in EsaPanel
 * so they are removed atomically when the panel mode transitions to 'chat'.
 */
export function ESABriefing(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center flex-1 gap-3 px-4 text-center">
      <ESASparkIcon size={64} radius={32} />
      <Typography variant="body2" color="tertiary">
        {t('esa.askAnything', 'Ask me anything')}
      </Typography>
    </div>
  );
}
